/**
 * Элемент с прямоугольной формой и иконкой в правом верхнем углу (Active, Passive).
 * Пример: ApplicationComponent, BusinessActor, TechnologyNode.
 */
import ElementNodeTypeBase from './ElementNodeTypeBase';
import {ASPECT_BEHAVIOR} from '../metamodel/Concept';
import {ARCHIMATE_PICTO_ICON_CORNER} from '../modelerX6/constants';
import {textAlignToLabelAttrs} from './textAlignUtil';

export default class DefaultElementNodeType extends ElementNodeTypeBase {
	/**
	 * Переопределяется в наследниках, например 'ApplicationComponent'.
	 */
	static get typeName() {
		return 'Element';
	}

	/**
	 * shapeId для rect-элементов: archimate:kebab-case(typeName).
	 */
	get shapeId() {
		return `archimate:${this._toKebabCase(this.constructor.typeName)}`;
	}

	buildNodeConfig(pathMap, options = {}) {
		const {
			id,
			x = 0,
			y = 0,
			width,
			height,
			label,
			fillColor,
			lineColor,
			textAlign,
			lineWidth,
		} = options;
		const align = textAlignToLabelAttrs(textAlign, {reserveForIcon: true});

		const w = width ?? this.defaultSize.width;
		const h = height ?? this.defaultSize.height;
		const iconRef = this.iconRef;

		if (!iconRef) {
			throw new Error(`Unsupported element type: ${this.constructor.typeName}`);
		}

		const iconBoxW = Math.round(0.22 * w);
		const iconBoxH = Math.round(0.45 * h);
		const iconPath = pathMap.getScaledPath(iconRef, {
			xScaleFactor: 1,
			yScaleFactor: 1,
			containerWidth: iconBoxW,
			containerHeight: iconBoxH,
			position: {mx: 0, my: 0},
		});
		const fillColorFinal = this.getDefaultFillColor(fillColor);
		const lineColorFinal = this.getDefaultLineColor(lineColor);
		const aspect = this.aspect;

		const strokeW = lineWidth != null && Number(lineWidth) >= 0 ? Number(lineWidth) : 0.8;
		const nodeAttrs = {
			body: {
				fill: fillColorFinal,
				stroke: lineColorFinal,
				strokeWidth: strokeW,
			},
			icon: {
				d: iconPath,
				fill: fillColorFinal,
				stroke: lineColorFinal,
				strokeWidth: strokeW,
				...ARCHIMATE_PICTO_ICON_CORNER,
			},
		};

		if (aspect === ASPECT_BEHAVIOR) {
			nodeAttrs.body.rx = 10;
			nodeAttrs.body.ry = 10;
		}

		if (label != null) {
			nodeAttrs.label = {
				text: label,
				...align,
				textWrap: {width: -70, height: '100%', ellipsis: true, breakWord: true},
			};
		}

		return {
			id,
			x,
			y,
			width: w,
			height: h,
			shape: this.shapeId,
			attrs: nodeAttrs,
			data: {iconRef},
		};
	}
}
